import { render } from "./AboutAiEntry.vue?vue&type=template&id=59c5a0dd&scoped=true"
import script from "./AboutAiEntry.vue?vue&type=script&lang=js"
export * from "./AboutAiEntry.vue?vue&type=script&lang=js"

import "./AboutAiEntry.vue?vue&type=style&index=0&id=59c5a0dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c5a0dd"]])

export default __exports__